/**
 * Created by shanie on 12/1/16.
 */
import { reducers as shippingQuoteModal } from 'dibs-request-shipping-modal';
import { combineReducers } from 'redux';
import creationState from './CreationReducer';
import editInlineState from './EditInlineReducer';
import emailState from './EmailReducer';
import modalState from './ModalReducer';
import uiState from './UiReducer';
import { favoritesNotificationsReducer } from './favoritesNotificationsReducers';

const FavoritesReducers = {
    shippingQuoteModal,
    favoritesNotificationsReducer,
    favorites: combineReducers({
        creationState,
        editInlineState,
        emailState,
        modalState,
        uiState,
    }),
};

export default FavoritesReducers;
